import React from "react";
import styled from "styled-components";
import { formats } from "common/constants";

const WrapperThreshold = styled.div`
  background: transparent;
  align-items: center;
  display: flex;
  margin-top: 20px;
  color: var(--text-primary);
`;

const LabelClick = styled.div`
  cursor: pointer;
  border-radius: 6px;
  background-color: var(--Signal-Blue-Light);
  color: #37abff;
  font-size: 12px;
  line-height: 115%;
  letter-spacing: 0.24px;
  padding: 4px 2px 2px 2px;
  font-family: "AllianceNo2-Light";
  margin-left: 5px;
  margin-top: -2px;
`;

const getLabel = ({ threshold, inverted, labelUnit}) => {
  if (threshold === "auto") {
    return "auto";
  }
  return `${inverted ? ">" : "<"} ${threshold}${labelUnit ? labelUnit : ""}`;
};

const Threshold = ({
  threshold,
  labelUnit,
  setDisplayModal,
  inverted,
  customThreshold,
}) => {
  if (threshold === undefined) {
    return null;
  }
  const label = getLabel({ threshold, inverted, labelUnit });
  return (
    <WrapperThreshold>
      <div>{threshold === "auto" ? "Warn:" : "Warn if"}</div>
      <LabelClick onClick={() => setDisplayModal(true)}>{label}</LabelClick>
      {threshold === "auto" && customThreshold !== undefined ? <div>{`(> ${formats.oneDecimal(customThreshold)}${labelUnit})`}</div>: null}
    </WrapperThreshold>
  );
};

export default Threshold;